import { gql } from '@apollo/client'

export const START_UNIFIED_ONBOARDING = gql`
  mutation startUnifiedOnboarding {
    startUnifiedOnboarding {
      success
    }
  }
`
